module.exports = __webpack_public_path__ + "static/media/leaf-big.1e0f824c.svg";